import { useQuery } from '@apollo/client';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import React, { FC, useContext, useEffect } from 'react';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';
import { InsuranceContext } from '@providers/InsuranceProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';
import { IAccountInfoQueryData } from '@folx-types/member';

import ACCOUNT_INFO_QUERY from '@graphql/queries/AccountInfo.query.gql';

import { IInsuranceDetailsStepContent } from './InsuranceDetailsStep.component';
import InsuranceDetailsStep from './InsuranceDetailsStep.component';

interface IInsuranceDetailsStepPageProps extends IFlowStepProps {}

const InsurancDetailsStepPage: FC<IInsuranceDetailsStepPageProps> = ({ path, stepKey }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "insurance-details-step" }) {
				title
				description
				tooltip
				tooltip_text
				first_name_label
				last_name_label
				member_id_label
				group_label
				is_policyholder_label
				policyholder_first_name_label
				policyholder_last_name_label
				policyholder_relationship_label
				policyholder_dob_label
			}
		}
	`);

	const {
		loading: accountLoading,
		data: accountData,
		error: accountError,
	} = useQuery<IAccountInfoQueryData>(ACCOUNT_INFO_QUERY);

	const member = accountData?.currentMember;

	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	const { provider } = useContext(InsuranceContext);

	useEffect(() => {
		if (!provider) {
			navigate('../insurance_provider');
		}
	}, []);

	const refinedContent: IInsuranceDetailsStepContent = keysToCamel(
		pageContent
	) as IInsuranceDetailsStepContent;

	const submit = (id: string) => {
		handleFormSubmission({ memberInsuranceId: id }, stepKey);
	};

	return (
		<InsuranceDetailsStep
			pageContent={refinedContent}
			member={member}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleFormSubmission={handleFormSubmission}
			handleNavBack={handleNavBack}
			provider={provider}
			submit={submit}
		/>
	);
};

export default InsurancDetailsStepPage;
